import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function recalculateDefaults() {
	//set vars based off size
}

function NavStyles({isExtended} = {}) {
	//#region Params
	let size = useContext(GlobalContext).size;
	let minimumMargin = useContext(GlobalContext).minimumMargin;
	let currentLocation = useContext(GlobalContext).getCurrentLocation();
	let isMobile = useContext(GlobalContext).isMobile;
	//#endregion

	//#region Style vars
	let backgroundColor = '#255C99';
	let position = 'static';
	let navHeight = useContext(GlobalContext).navHeight;
	//#endregion

	//#region seting vars based off params
	if (currentLocation == 'index' && !isExtended) {
		backgroundColor = 'transparent';
		position = 'fixed';
	}
	if (isMobile || size === 'sm' || size === 'md') {
		navHeight = 'auto';
	}
	//#endregion

	return {
		outerContainer: () => {
			return {
				display: 'flex',
				width: '100%',
				height: navHeight,
				backgroundColor: backgroundColor,
				position: position,
				zIndex: 2,
			};
		},
		side: (side, flexDirection, textAlignDirection, isExtended) => {
			let marginTop = 'auto';

			flexDirection = flexDirection || 'row';
			textAlignDirection = textAlignDirection || 'ltr';
			let style = {
				display: 'flex',
				flexDirection: flexDirection,
				marginTop: 'auto',
				marginBottom: 'auto',
				listStyleType: 'none',
				textDecoration: 'none',
				padding: 0,
				direction: textAlignDirection,
			};
			if (side === 'left') {
				style.marginLeft = `${minimumMargin}rem`;
				style.marginRight = 'auto';
			} else {
				style.marginRight = `${minimumMargin}rem`;
				style.marginLeft = 'auto';
			}
			if (isMobile || size === 'sm' || size === 'md') {
				style.marginTop = '1rem';
				style.marginBottom = '1rem';
				style.height = 'min-content';
				if (side === 'right') {
					style.marginTop = isExtended ? '1.4rem' : 'auto';
					style.marginBottom = isExtended ? '1rem' : 'auto';
				}
			}
			return style;
		},
		logoIcon: () => {
			return {
				height: 'fitContent',
				marginBottom: 'auto',
				marginTop: 'auto',
			};
		},
		li: () => {
			return {};
		},
		link: () => {
			let height = isMobile || size === 'sm' || size === 'md' ? 'auto' : '100%';
			return {
				textDecoration: 'none',
				color: 'white',
				display: 'flex',
				height: height,
			};
		},
		titleText: () => {
			return {
				fontSize: '1.5rem',
			};
		},
		navText: textAlign => {
			textAlign = textAlign || 'left';
			return {
				marginTop: 'auto',
				marginBottom: 'auto',
				textAlign: textAlign,
			};
		},
		hamburger: () => {
			return {
				color: 'white',
				fontSize: '1.5rem',
				height: 'min-content',
			};
		},
	};
}

export default NavStyles;

function getLocation(path) {
	path = path || window.location.pathname;
	let location = 'home';
	switch (path) {
		case '/':
			location = 'index';
			break;
		case '/home':
			location = 'home';
			break;
		case '/ccmrs':
			location = 'ccmrs';
			break;
	}

	return location;
}
